import { DocketEntryActions } from './actions'
import { DocketEntryGetters } from './getters'
import { DocketEntryMutations } from './mutations'
import { DocketEntryState } from './state'

export const DOCKET_ENTRY_NAMESPACE = 'docketEntry'

export const DocketEntry = {
  namespaced: true,
  state: DocketEntryState,
  actions: DocketEntryActions,
  mutations: DocketEntryMutations,
  getters: DocketEntryGetters,
}
